export var PriceType;
(function (PriceType) {
    PriceType["UNKNOWN_PRICE_TYPE"] = "UNKNOWN_PRICE_TYPE";
    PriceType["FIXED_AMOUNT"] = "FIXED_AMOUNT";
})(PriceType || (PriceType = {}));
export var AppliedAt;
(function (AppliedAt) {
    AppliedAt["UNKNOWN_APPLIED_AT"] = "UNKNOWN_APPLIED_AT";
    /** Indicates that the fee will be added to the first payment */
    AppliedAt["FIRST_PAYMENT"] = "FIRST_PAYMENT";
})(AppliedAt || (AppliedAt = {}));
export var Period;
(function (Period) {
    Period["UNKNOWN_PERIOD"] = "UNKNOWN_PERIOD";
    Period["DAY"] = "DAY";
    Period["WEEK"] = "WEEK";
    Period["MONTH"] = "MONTH";
    Period["YEAR"] = "YEAR";
})(Period || (Period = {}));
export var StartType;
(function (StartType) {
    StartType["UNKNOWN_START_TYPE"] = "UNKNOWN_START_TYPE";
    /** Plan starts on purchase */
    StartType["ON_PURCHASE"] = "ON_PURCHASE";
    /** Allows UoU to select when the plan should start */
    StartType["CUSTOM"] = "CUSTOM";
})(StartType || (StartType = {}));
export var EndType;
(function (EndType) {
    EndType["UNKNOWN_END_TYPE"] = "UNKNOWN_END_TYPE";
    /** Indicates that plan should last until UoU cancels a plan (unlimited duration) */
    EndType["UNTIL_CANCELLED"] = "UNTIL_CANCELLED";
    /** Indicates that plan should end after some number of billing cycle autorenewals */
    EndType["CYCLES_COMPLETED"] = "CYCLES_COMPLETED";
})(EndType || (EndType = {}));
export var Visibility;
(function (Visibility) {
    Visibility["UNKNOWN_VISIBILITY"] = "UNKNOWN_VISIBILITY";
    Visibility["PUBLIC"] = "PUBLIC";
    /** New customers won’t be able to purchase private plans, but existing plan holders will still be able to use it */
    Visibility["PRIVATE"] = "PRIVATE";
})(Visibility || (Visibility = {}));
export var Status;
(function (Status) {
    Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    Status["ACTIVE"] = "ACTIVE";
})(Status || (Status = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    Type["PLAN"] = "PLAN";
    Type["ADD_ON"] = "ADD_ON";
})(Type || (Type = {}));
export var TaxableAddress;
(function (TaxableAddress) {
    TaxableAddress["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    TaxableAddress["BILLING"] = "BILLING";
    TaxableAddress["BUSINESS"] = "BUSINESS";
})(TaxableAddress || (TaxableAddress = {}));
export var ValidationStrategy;
(function (ValidationStrategy) {
    ValidationStrategy["UNKNOWN_VALIDATION_STRATEGY"] = "UNKNOWN_VALIDATION_STRATEGY";
    ValidationStrategy["ON_BEHALF"] = "ON_BEHALF";
    ValidationStrategy["PREVIEW"] = "PREVIEW";
})(ValidationStrategy || (ValidationStrategy = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SortType;
(function (SortType) {
    /** Should sort by number of matches */
    SortType["COUNT"] = "COUNT";
    /** Should sort by value of the field alphabetically */
    SortType["VALUE"] = "VALUE";
})(SortType || (SortType = {}));
export var SortDirection;
(function (SortDirection) {
    /** Should sort in descending order */
    SortDirection["DESC"] = "DESC";
    /** Should sort in ascending order */
    SortDirection["ASC"] = "ASC";
})(SortDirection || (SortDirection = {}));
export var MissingValues;
(function (MissingValues) {
    /** Should missing values be excluded from the aggregation results */
    MissingValues["EXCLUDE"] = "EXCLUDE";
    /** Should missing values be included in the aggregation results */
    MissingValues["INCLUDE"] = "INCLUDE";
})(MissingValues || (MissingValues = {}));
export var ScalarType;
(function (ScalarType) {
    ScalarType["UNKNOWN_SCALAR_TYPE"] = "UNKNOWN_SCALAR_TYPE";
    /** Count of distinct values */
    ScalarType["COUNT_DISTINCT"] = "COUNT_DISTINCT";
    /** Minimum value */
    ScalarType["MIN"] = "MIN";
    /** Maximum value */
    ScalarType["MAX"] = "MAX";
    /** Sum of values */
    ScalarType["SUM"] = "SUM";
    /** Average of values */
    ScalarType["AVG"] = "AVG";
})(ScalarType || (ScalarType = {}));
export var NestedAggregationType;
(function (NestedAggregationType) {
    NestedAggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** An aggregation where result buckets are dynamically built - one per unique value */
    NestedAggregationType["VALUE"] = "VALUE";
    /** An aggregation, where user can define set of ranges - each representing a bucket */
    NestedAggregationType["RANGE"] = "RANGE";
    /** A single-value metric aggregation - e.g. min, max, sum, avg */
    NestedAggregationType["SCALAR"] = "SCALAR";
    /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
    NestedAggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
})(NestedAggregationType || (NestedAggregationType = {}));
export var Interval;
(function (Interval) {
    Interval["UNKNOWN_INTERVAL"] = "UNKNOWN_INTERVAL";
    /** Yearly interval */
    Interval["YEAR"] = "YEAR";
    /** Monthly interval */
    Interval["MONTH"] = "MONTH";
    /** Weekly interval */
    Interval["WEEK"] = "WEEK";
    /** Daily interval */
    Interval["DAY"] = "DAY";
    /** Hourly interval */
    Interval["HOUR"] = "HOUR";
    /** Minute interval */
    Interval["MINUTE"] = "MINUTE";
    /** Second interval */
    Interval["SECOND"] = "SECOND";
})(Interval || (Interval = {}));
export var AggregationType;
(function (AggregationType) {
    AggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** An aggregation where result buckets are dynamically built - one per unique value */
    AggregationType["VALUE"] = "VALUE";
    /** An aggregation, where user can define set of ranges - each representing a bucket */
    AggregationType["RANGE"] = "RANGE";
    /** A single-value metric aggregation - e.g. min, max, sum, avg */
    AggregationType["SCALAR"] = "SCALAR";
    /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
    AggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
    /** Multi-level aggregation, where each next aggregation is nested within previous one */
    AggregationType["NESTED"] = "NESTED";
})(AggregationType || (AggregationType = {}));
export var Mode;
(function (Mode) {
    /** Any of the search terms must be present */
    Mode["OR"] = "OR";
    /** All search terms must be present */
    Mode["AND"] = "AND";
})(Mode || (Mode = {}));
//# sourceMappingURL=types.impl.js.map